export enum StatusEnumDocument {
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  READY = 'READY',
  UPDATING = 'UPDATING',
  ERROR = 'ERROR',
  CANCELLING = 'CANCELLING',
}
